import { render, staticRenderFns } from "./WriterOrderPostTable.vue?vue&type=template&id=61032c90&scoped=true&"
import script from "./WriterOrderPostTable.vue?vue&type=script&lang=js&"
export * from "./WriterOrderPostTable.vue?vue&type=script&lang=js&"
import style0 from "./WriterOrderPostTable.vue?vue&type=style&index=0&id=61032c90&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61032c90",
  null
  
)

export default component.exports